import { render, staticRenderFns } from "./chatGroupCreateDialog.vue?vue&type=template&id=ef41397e&scoped=true"
import script from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./chatGroupCreateDialog.vue?vue&type=style&index=0&id=ef41397e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef41397e",
  null
  
)

export default component.exports